import React from 'react'
import PropTypes from 'prop-types'
import './style.sass'

const PillContainer = ({ items, isBorderless = false }) => {
  return (
    <div className="pill-container-container">
      <div className={isBorderless ? "pill-container-wrapper-border-less" : "pill-container-wrapper"}>
        {items.map((item, i) => <span key={`${item}${i}`} className="pill-container-item">{item}</span>)}
      </div>
    </div>
  )
}

PillContainer.propTypes = {
  items: PropTypes.array,
  isBorderless: PropTypes.bool
}

export default PillContainer
